export const MeFaculty = [
  {
    "designation": "Professor",
    "Name": "Dr. G. Bhanodaya Reddy (Leave on loss of Pay)",
    "Phone": "(+91)-9848175066",
    "Email": "bhanodayareddy_svuce@yahoo.co.in",
    "Details": "NA"
  },
  {
    "designation": "Professor",
    "Name": "Dr. P. Venkataramaiah",
    "Phone": "	(+91)-9291602889",
    "Email": "	pvramaiah@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590925"
  },
  {
    "designation": "Professor",
    "Name": "Dr. V. Diwakar Reddy",
    "Phone": "(+91)-9440088282",
    "Email": "vdrsvuce@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/579504"
  },

  {
    "designation": "Professor",
    "Name": "Dr. P. Hema",
    "Phone": "(+91)-9490247265",
    "Email": "hemasvumech@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/248885"
  }, {
    "designation": "Professor",
    "Name": "Dr. K. Dharma Reddy ",
    "Phone": "(+91)-9494697899, (+91)-9493105099",
    "Email": "kdharmareddy@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590863"
  },
  {
    "designation": "Associate Professor",
    "Name": "Sri. K. Rajesh Babu",
    "Phone": "(+91)-9908502997",
    "Email": "rajesh.babuiit@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590940"
  },

  {
    "designation": "Associate Professor",
    "Name": "Dr. A. Sreenivasulu Reddy",
    "Phone": "(+91)-9848252269",
    "Email": "allampati_sr@rediffmail.com",
    "Details": "https://svuniversity.irins.org/profile/591031"
  },

  {
    "designation": "Assistant Professor",
    "Name": "Dr. K. Aruna",
    "Phone": "(+91)-9000109058",
    "Email": "aruna_svu@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590894"
  },

  {
    "designation": "Academic Consultant",
    "Name": "Dr. N. Bala Subramanyam",
    "Phone": "+91 9989366203",
    "Email": "dr.balusvu@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591640"
  }, {
    "designation": "Academic Consultant",
    "Name": "Kondeti Vijayalakshmi",
    "Phone": "(+91)-9059525737",
    "Email": "vijayavasu19@gail.com",
    "Details": "https://svuniversity.irins.org/profile/590986"
  },
  {
    "designation": "Academic Consultant",
    "Name": "M. Reddaiah",
    "Phone": "(+91)-9642452985",
    "Email": "madpuri.reddaiah@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590892"
  },
  {
    "designation": "Academic Consultant",
    "Name": "Karanam Pavan Kumar",
    "Phone": "(+91)-9032962160",
    "Email": "kpavan4086@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590920"
  },
  {
    "designation": "Academic Consultant",
    "Name": "Sibbala Vani",
    "Phone": "(+91)-9989074242",
    "Email": "vanisibba@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/591270"
  },

  {
    "designation": "Academic Consultant",
    "Name": "P. Gopi",
    "Phone": "(+91)-9704401684",
    "Email": "gopipadaveti.81@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590922"
  },
  {
    "designation": "Academic Consultant",
    "Name": "B. Raghavendra Prasad NAYAK",
    "Phone": "(+91)-9849470877",
    "Email": "raghu536@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590895"
  },
  {
    "designation": "Academic Consultant",
    "Name": "A V N S Kiran",
    "Phone": "(+91)-9492188838",
    "Email": "kiran.avns321@gamil.com",
    "Details": "https://svuniversity.irins.org/profile/590896"
  },
  {
    "designation": "Academic Consultant",
    "Name": "D. Jyosthna",
    "Phone": "(+91)-9533543221",
    "Email": "jyoshnaraya@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590904"
  },
  {
    "designation": "Academic Consultant",
    "Name": "T. Ebesu",
    "Phone": "(+91)-7036350200",
    "Email": "ebesh.5star@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590866"
  },{
    "designation": "Academic Consultant",
    "Name": "Mr.Gali Chiranjeevi Naidu",
    "Phone": "(+91)-9100022229",
    "Email": "chiru.10081991@gmail.com",
    "Details": "https://svuniversity.irins.org/profile/590882"
  }
  


]